import {
  DB_LIST_PROJECTS,
  DB_GET_PROJECT,
  DB_PROJECT_SURVEYS,
  DB_PROJECT_CLIENTS,
  PROJECT_SURVEY_SYNC_PENDING,
  PROJECT_SURVEY_SYNC_NUM,
  PROJECT_SET_PROPERTY_NUM,
  PROJECT_SET_PROPERTY_PENDING,
  DB_PROJECT_CHARTS,
  DB_PROJECT_CHART_CLIENTS,
} from "constants/ActionTypes"

const INIT_STATE = {
  db_projects: [],
  db_project: null,
  db_project_surveys: null,
  db_project_clients: null,
  db_project_survey_sync_pending: 0,
  db_project_survey_sync_num: 0,
  db_project_set_property_pending: 0,
  db_project_set_property_num: 0,
  db_project_charts: [],
  db_project_chart_clients: null,
}

export default (state = INIT_STATE, action) => {
  switch(action.type) {
    case DB_LIST_PROJECTS: {
      return {
        ...state,
        db_projects: action.payload.projects
      }
    }

    case DB_GET_PROJECT: {
      return {
        ...state,
        db_project: action.payload.project
      }
    }

    case DB_PROJECT_SURVEYS: {
      return {
        ...state,
        db_project_surveys: action.payload.project_surveys
      }
    }

    case DB_PROJECT_CLIENTS: {
      return {
        ...state,
        db_project_clients: action.payload.project_clients
      }
    }

    case PROJECT_SURVEY_SYNC_PENDING: {
      return {
        ...state,
        db_project_survey_sync_pending: action.payload
      }
    }

    case PROJECT_SURVEY_SYNC_NUM: {
      return {
        ...state,
        db_project_survey_sync_num: action.payload
      }
    }

    case PROJECT_SET_PROPERTY_PENDING: {
      return {
        ...state,
        db_project_set_property_pending: action.payload
      }
    }

    case PROJECT_SET_PROPERTY_NUM: {
      return {
        ...state,
        db_project_set_property_num: action.payload
      }
    }

    case DB_PROJECT_CHARTS: {
      return {
        ...state,
        db_project_charts: action.payload.project_charts
      }
    }
    
    case DB_PROJECT_CHART_CLIENTS: {
      return {
        ...state,
        db_project_chart_clients: action.payload.project_chart_clients
      }
    }

    default:
      return state;
  }
}